SharedUser =
  setGrpnUsrHeader: (options) ->
    if options?.headers?
      options.headers['x-csrf-token'] = $('meta[name="csrf-token"]').attr('content')
    if options?.data? && options?.type is 'POST'
      options.data._csrf = $('meta[name="csrf-token"]').attr('content')

module.exports = SharedUser
